import configStorage from './config-storage';

const configure = (incomingConfig) => {
  const currentConfig = configStorage.get();

  configStorage.set({
    ...currentConfig,
    ...incomingConfig,
  });
};

export default configure;
